import { render, staticRenderFns } from "./wholesale-grid-dialog.vue?vue&type=template&id=345168e0&scoped=true"
import script from "./wholesale-grid-dialog.vue?vue&type=script&lang=js"
export * from "./wholesale-grid-dialog.vue?vue&type=script&lang=js"
import style0 from "./wholesale-grid-dialog.vue?vue&type=style&index=0&id=345168e0&prod&lang=scss&scoped=true"
import style1 from "./wholesale-grid-dialog.vue?vue&type=style&index=1&id=345168e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345168e0",
  null
  
)

export default component.exports